var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.015,
    height: 19.999,
    viewBox: "0 0 20.015 19.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-user-5752333",
    transform: "translate(-84.22 -14.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37616",
    "data-name": "Path 37616",
    d: "M99.7,32.018c.012-.1.023-.194.03-.29q.016-.207.016-.426a5.514,5.514,0,1,0-11.028,0q0,.219.016.426c.007.1.017.193.03.29h0a9.505,9.505,0,0,0,10.937,0ZM88.085,31.5c-.2-.169-.39-.345-.574-.528a9.5,9.5,0,1,1,13.435,0c-.182.184-.374.36-.572.528,0-.065,0-.129,0-.193h0a6.153,6.153,0,0,0-4.562-5.94,3.673,3.673,0,1,0-3.172,0A6.152,6.152,0,0,0,88.082,31.3c0,.063,0,.128,0,.193Zm8.293-11.6a3.043,3.043,0,1,0,.889,2.15,3.043,3.043,0,0,0-.889-2.15Z",
    transform: "translate(0 0)",
    fill: "#61277f",
    stroke: "#f6f6f6",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarUser);
export default __webpack_public_path__ + "static/media/sidebar-user.7eb5d612d1c31eafbf090c3c96647003.svg";
export { ForwardRef as ReactComponent };